import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { ICreditScoreSimulatorSlice, ISimulation } from './types';

const initialState: ICreditScoreSimulatorSlice = {
  scenarios: null,
};

const creditScoreSimulatorSlice = createAppSlice({
  name: 'creditScoreSimulator',
  initialState,
  reducers: {
    setSimulatorScenarios(state, action: PayloadAction<ISimulation[]>) {
      state.scenarios = action.payload;
    },
    clearSimulatorScenarios(state) {
      state.scenarios = null;
    },
  },
});

export const { setSimulatorScenarios, clearSimulatorScenarios } =
  creditScoreSimulatorSlice.actions;
export default creditScoreSimulatorSlice.reducer;
